export enum QuotationStep {
  LANDING = 'Landing',
  STEP_1 = 'Step 1',
  STEP_2 = 'Step 2',
  STEP_2_ALT = 'Step 2-alt',
  STEP_3 = 'Step 3'
}
